
export const untanglColors = {
  orange: '#055a73',    // primary
  green: '#9DCC93',     // success
  tealblue: '#7BB5BF',  // info
  purple: '#511966',    // warning
  red: '#C51A1B',       // danger
  textgrey: '#6B6B6B'
};